/* ============================================================
   Mobile drawer — §P
   Event-delegated, idempotent. Survives theme-editor section
   re-renders without double-binding listeners.
   ============================================================ */

if (!window.__drawerInit) {
  window.__drawerInit = true;

  const html = document.documentElement;

  const openDrawer = (drawer) => {
    drawer.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', '');
    html.style.overflow = 'hidden';
  };

  const closeDrawer = (drawer) => {
    if (typeof drawer.close === 'function') drawer.close();
    else drawer.removeAttribute('open');
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) {
      const id = toggle.getAttribute('aria-controls');
      const drawer = id ? document.getElementById(id) : document.querySelector('[data-drawer]');
      if (!drawer) return;
      openDrawer(drawer);
      toggle.setAttribute('aria-expanded', 'true');
      return;
    }

    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      const drawer = closeBtn.closest('[data-drawer]');
      if (drawer) closeDrawer(drawer);
      return;
    }

    if (e.target.matches('[data-drawer]')) {
      const drawer = e.target;
      const inner = drawer.querySelector('.mobile-drawer__inner');
      if (!inner) return;
      const rect = inner.getBoundingClientRect();
      const outside =
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom;
      if (outside) closeDrawer(drawer);
    }
  });

  document.addEventListener(
    'close',
    (e) => {
      if (!(e.target instanceof Element) || !e.target.matches('[data-drawer]')) return;
      html.style.overflow = '';
      const id = e.target.id;
      const toggle = id
        ? document.querySelector('[data-drawer-toggle][aria-controls="' + id + '"]')
        : document.querySelector('[data-drawer-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    },
    true
  );
}
